<script>
  export let currentPage;
  export let lastPage;
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  function range(size, startAt = 0) {
    return [...Array(size).keys()].map(i => i + startAt);
  }
  function changePage(page) {
    if (page !== currentPage) {
      dispatch('change', page);
    }
  }
</script>

<nav class="pagination">
  <ul>
    {#if (currentPage !== 1)}
      <li class="pagination-previous">
        <span class="a-link" on:click="{() => changePage(currentPage - 1)}">
          <span aria-hidden="true">«</span>
        </span>
      </li>
    {/if}
    {#each range(lastPage, 1) as page}
    <li class='{page === currentPage ? "active": ""}'>
      <span class="a-link" on:click="{() => changePage(page)}">{page}</span>
    </li>
    {/each}
    {#if (currentPage !== lastPage)}
      <li class="pagination-next">
        <span class="a-link" on:click="{() => changePage(currentPage + 1)}">
          <span aria-hidden="true">»</span>
        </span>
      </li>
    {/if}
  </ul>
</nav>

<style type="text/scss">
  @import '../../public/styles/variables';
  @import '../../public/styles/mixins';
  
  .pagination {
    display: block;
    margin: 30px auto 15px;
    padding: 0 10% 0;
    text-align: center;
    ul {
      display: block;
      padding-left: 0;
      list-style: none;
      li {
        cursor: pointer;
        display: inline-block;
        color: $idro-palette-light-blue;
        width: 30px;
        height: 20px;
        margin: 0 5px 4px;
        @include border-radius(20px);
        background: rgba(0, 0, 0, 0.55);
        transition-timing-function: cubic-bezier(0.17, 0.67, 0.83, 0.67);
        @include transition(0.4s);
        padding: 0;
        &.active {
          background: #3da6ae;
          box-shadow: 0 0 0 0.2rem transparentize(#3da6ae, .6);
        }
      }
      &::before, &::after {
        content: '';
        display: table;
      }
      &::after {
        clear: both;
      }
      .a-link {
        display: block;
        outline: 0;
        color: $idro-palette-light-blue;
        padding: 0;
        margin: 0;
        width: 30px;
        height: 20px;
        @include border-radius(20px);
        &:hover {
          background: #3da6ae;
        }
        &:focus {
          box-shadow: 0 0 0 0.2rem transparentize(#3da6ae, .5);
        }
      }
      span {
        color: $idro-palette-light-blue;
        display: block;
        padding: 1px 0 0 5px;
        width: 10px;
        height: 10px;
        @include border-radius(20px);
        &:hover {
          background: none;
        }
      }
    }
  }
</style>